  export const setQueryParam = (key, value) => {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.pushState({}, "", url.toString());
};
  export const clearQueryParam = () => {
   const baseUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, baseUrl);
};

//-------------------------------------------------------------- Validations ------------------
export const validatePhoneNumber = (phone) => {

  
  // Basic format validation: +[country code][number] or just numbers
  const phoneRegex = /^\+?[1-9]\d{7,14}$/;
  
  if (!phoneRegex.test(phone.trim().replace(/\s+/g, ''))) {
    return {
      isValid: false,
      message: 'Please enter a valid phone number '
    };
  }

  return { isValid: true, message: '' };
};

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const validateEmail = (email) => {
  if (!email || typeof email !== 'string') {
    return { isValid: false, message: 'Please enter a valid email address' };
  }
  const value = email.trim();
  console.log('Validating email:', value);
  if (!emailRegex.test(value)) {
      console.log('Validating email:invalid', value);
    return { isValid: false, message: 'Please enter a valid email address' };
  }
  return { isValid: true, message: '' };
};

//------------------------------------------------------------------------------------------

import { useEffect, useState } from "react";

export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);

  return isMobile;
}